export const getContactHeaders = () => [
  {
    title: I18n.t('activerecord.attributes.v4/organization_contact.name'),
    field: 'name'
  },
  {
    title: I18n.t('activerecord.attributes.v4/organization_contact.position'),
    field: 'position',
    render: rowData => rowData.position
      ? I18n.t(`v4/organization_contact.positions.${rowData.position}`, { defaultValue: rowData.position })
      : ''
  },
  {
    title: I18n.t('activerecord.attributes.v4/organization_contact.email'),
    field: 'email'
  },
  {
    title: I18n.t('activerecord.attributes.v4/organization_contact.phone_full'),
    field: 'phone_full'
  },
  {
    title: I18n.t('activerecord.attributes.v4/organization_contact.language'),
    field: 'language',
    render: rowData => rowData.language
      ? I18n.t(`v4/organization_contact.languages.${rowData.language.replace('-', '_')}`, { defaultValue: rowData.language })
      : ''
  }
]

export const languages = () => [
  { id: 'pt-BR', name: I18n.t('v4/organization_contact.languages.pt_BR') },
  { id: 'en', name: I18n.t('v4/organization_contact.languages.en') },
  { id: 'es-MX', name: I18n.t('v4/organization_contact.languages.es_MX') }
]

export const positions = () => [
  { id: 'technical_support', name: I18n.t('v4/organization_contact.positions.technical_support') },
  { id: 'agronomic', name: I18n.t('v4/organization_contact.positions.agronomic') },
  { id: 'financial', name: I18n.t('v4/organization_contact.positions.financial') },
  { id: 'owner', name: I18n.t('v4/organization_contact.positions.owner') },
  { id: 'manager', name: I18n.t('v4/organization_contact.positions.manager') },
  { id: 'other', name: I18n.t('v4/organization_contact.positions.other') }
]

export const validate = values => {
  const errors = {}

  if (!values.name) {
    errors.name = I18n.t('validations.required')
  }

  return errors
}
